"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var userLogin_1 = require("../../model/userLogin");
var service_1 = require("../../../library/base/service");
var DeviceLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(DeviceLogin, _super);
    function DeviceLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '生物识别登录';
        _this.code = '101045';
        _this.desc = "\u901A\u8FC7\u751F\u6210\u8BBE\u5907\u79D8\u94A5\u767B\u5F55\n\u53EF\u7528\u4E8E\u6307\u7EB9\u767B\u5F55\u3001\u4EBA\u8138\u8BC6\u522B\u767B\u5F55\u4EE5\u53CA\u624B\u52BF\u767B\u5F55\n";
        _this.requestParams = new userLogin_1.DeviceLoginRequest();
        // public responseParams: LoginResponse;
        _this.method = fetch_1.Methods.POST;
        _this.isSecurity = false;
        return _this;
    }
    return DeviceLogin;
}(service_1.BaseService));
exports.DeviceLogin = DeviceLogin;
//# sourceMappingURL=deviceLogin.js.map